import React from 'react'
import { InscryptionsSec } from './inscryptionsSec'

export const Inscryption = () => {
  return (
    <InscryptionsSec />
  )
}
